import { useWeb3Modal } from '@web3modal/wagmi/react'

export function Disconnected() {
	const { open } = useWeb3Modal()
    return (
		<div>
		  <button onClick={() => open()}>Conect Wallet</button>
		</div>
	)
}